/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetConfig200Response,
} from '../models/index';
import {
    GetConfig200ResponseFromJSON,
    GetConfig200ResponseToJSON,
} from '../models/index';

export interface GetDemoPngRequest {
    domain: string;
    brandId: string;
}

export interface GetGeneratedZipRequest {
    domain: string;
    brandId: string;
}

export interface PutConfigRequest {
    getConfig200Response: GetConfig200Response;
}

/**
 * 
 */
export class QrApi extends runtime.BaseAPI {

    /**
     */
    async getConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConfig200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/qr/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConfig200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConfig200Response> {
        const response = await this.getConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getDemoPngRaw(requestParameters: GetDemoPngRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling getDemoPng().'
            );
        }

        if (requestParameters['brandId'] == null) {
            throw new runtime.RequiredError(
                'brandId',
                'Required parameter "brandId" was null or undefined when calling getDemoPng().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['domain'] != null) {
            queryParameters['domain'] = requestParameters['domain'];
        }

        if (requestParameters['brandId'] != null) {
            queryParameters['brandId'] = requestParameters['brandId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/qr/demo-png`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getDemoPng(requestParameters: GetDemoPngRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getDemoPngRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGeneratedZipRaw(requestParameters: GetGeneratedZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling getGeneratedZip().'
            );
        }

        if (requestParameters['brandId'] == null) {
            throw new runtime.RequiredError(
                'brandId',
                'Required parameter "brandId" was null or undefined when calling getGeneratedZip().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['domain'] != null) {
            queryParameters['domain'] = requestParameters['domain'];
        }

        if (requestParameters['brandId'] != null) {
            queryParameters['brandId'] = requestParameters['brandId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/qr/generate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getGeneratedZip(requestParameters: GetGeneratedZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getGeneratedZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async putConfigRaw(requestParameters: PutConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getConfig200Response'] == null) {
            throw new runtime.RequiredError(
                'getConfig200Response',
                'Required parameter "getConfig200Response" was null or undefined when calling putConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/qr/config`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetConfig200ResponseToJSON(requestParameters['getConfig200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async putConfig(requestParameters: PutConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putConfigRaw(requestParameters, initOverrides);
    }

}
